import { render, staticRenderFns } from "./Dilemma.vue?vue&type=template&id=2452a7fd&scoped=true&"
import script from "./Dilemma.vue?vue&type=script&lang=js&"
export * from "./Dilemma.vue?vue&type=script&lang=js&"
import style0 from "./Dilemma.vue?vue&type=style&index=0&id=2452a7fd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2452a7fd",
  null
  
)

export default component.exports